// extracted by mini-css-extract-plugin
module.exports = {"container":"RichText_container__cYwXP"};